const PageContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='w-full h-full flex justify-center min-h-[calc(100vh-var(--navigation-height)-var(--total-section-min-height))]'>
      <div className='max-w-[1440px] w-full p-[48px] max-lg:px-[16px] max-lg:py-[32px]'>{children}</div>
    </div>
  );
};

export default PageContent;
